export default __webpack_public_path__ + "static/smartWorkflowImg1-cab1c5febd86177b2a06e4e32b468f94.png";